import Vue from 'vue'
import App from './App.vue'
import router from './router.js'
import ToggleButton from 'vue-js-toggle-button'
import ProgressBar from 'vuejs-progress-bar'
// import VueProgressBar from 'vue-progressbar'

import './icons';


// Bootstrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'



Vue.config.productionTip = false
Vue.use(ToggleButton)
Vue.use(ProgressBar)

// const options = {
//   color: '#bffaf3',
//   failedColor: '#874b4b',
//   thickness: '5px',
//   transition: {
//     speed: '0.2s',
//     opacity: '0.6s',
//     termination: 300
//   },
//   autoRevert: true,
//   location: 'left',
//   inverse: false
// }

// Vue.use(VueProgressBar,options)


Vue.prototype.$productWatchList = [];
Vue.prototype.$selected_download = [];
Vue.prototype.$first_status = 1;
Vue.prototype.$store_app_data = {};
Vue.prototype.$store_sel_product = {};
Vue.prototype.$store_active_cat = {};
Vue.prototype.$store_sel_product_pos;

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
